const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/venues/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
/* eslint-disable @typescript-eslint/no-use-before-define */

import { getFindAllVenuesQueryOptions, getFindVenueCategoriesQueryOptions } from '@api';
import { createTableQuerySchema } from '@common';
import { createFileRoute } from '@tanstack/react-router';
import { t } from 'i18next';
const DEFAULT_PAGE_SIZE = 25;
const MIN_PAGE = 1;
const MAX_PAGE_SIZE = 200;
const venuesSearchSchema = createTableQuerySchema({
  defaultPageSize: DEFAULT_PAGE_SIZE,
  minPage: MIN_PAGE,
  maxPageSize: MAX_PAGE_SIZE,
  minPageSize: DEFAULT_PAGE_SIZE
});
export const Route = createFileRoute('/_rootLayout/venues/')({
  validateSearch: search => venuesSearchSchema.parse(search),
  loader: async ({
    context: {
      queryClient
    },
    location
  }) => {
    const search = venuesSearchSchema.parse(location.search);
    queryClient.ensureQueryData(getFindAllVenuesQueryOptions(search));
    queryClient.ensureQueryData(getFindVenueCategoriesQueryOptions());
    return {
      crumb: t('NAVIGATION.VENUES'),
      to: '/venues'
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});